import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChevronTriangleDownMedium"><Path d="M15.104 9.75H8.89599C8.04631 9.75 7.58378 10.7426 8.13028 11.3932L11.2343 15.0884C11.6339 15.5642 12.3661 15.5642 12.7657 15.0884L15.8697 11.3932C16.4162 10.7426 15.9537 9.75 15.104 9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChevronTriangleDownMedium;
